import { ObjectLike } from '@/types/objectlike.types';
import serviceProvider from '@/services/service-provider';
import { iUser } from '@/entities/user/user.types';
import { iReview } from '@/entities/review/review.types';

export default function useCommentFunctions(
  commentVariables: ObjectLike,
  reviewActionsVariables: ObjectLike,
  $store: any,
  $emit: any,
) {
  const { comment, loading } = commentVariables;

  async function post() {
    const storeUser: iUser = $store.getters['user/user'];
    const { reviewInstance } = reviewActionsVariables;

    loading.value = true;
    const newReview = await serviceProvider
      .review
      .comment(reviewInstance.value as iReview, storeUser.id, storeUser.gamertag, comment.value);
    reviewInstance.value = newReview;
    comment.value = '';
    loading.value = false;
    $emit('new-comment');
  }

  function addText(value: string) {
    comment.value = value;
  }

  return {
    post,
    addText,
  };
}
